import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as Transcripts from '@trinity/chat/api/interfaces/transcripts';

type Props = {
  transcriptId: number;
};

export const useTranscriptionHighlights = (props: Props, options: Options = {}) => {

  const query = useQuery({
    queryKey: ['transcript-highlights', props] as const,
    queryFn: ({ queryKey }) => {
      const params = queryKey[1];
      /*return apiClient.transcripts.getTranscriptHighlights(params)
        .then(res => res.highlights);
        */
      return Promise.resolve([]); // Not implemented yet
    },
    ...options,
  });

  return query;
};

type Data = Transcripts.GetTranscriptHighlights.Response['highlights'];
type QK = readonly [string, Props];

type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QK>, 'queryKey' | 'queryFn'>;